module.exports = __webpack_public_path__ + "static/media/scythe.2f5a758b.svg";